'use client'

import { useEffect, useRef, useState } from 'react'

import { cn } from '@/lib/utils'

const DEFAULT_HEIGHT = 320

interface NativeBannerProps {
  className?: string
  height?: number
}

export default function NativeBanner({ className, height }: NativeBannerProps) {
  const [autoHeight, setAutoHeight] = useState(DEFAULT_HEIGHT)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.source !== iframeRef.current?.contentWindow) return
      if (
        typeof event.data === 'object' &&
        event.data?.type === 'native-banner-height' &&
        typeof event.data?.height === 'number' &&
        Number.isFinite(event.data.height)
      ) {
        setAutoHeight(Math.min(Math.max(event.data.height, 80), 600))
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  const iframeHeight = height ?? autoHeight

  return (
    <div
      className={cn(
        'flex justify-center overflow-hidden bg-transparent',
        className,
      )}
      style={{ height: iframeHeight }}
    >
      <iframe
        ref={iframeRef}
        title="Native Banner"
        src="/native_banner.html"
        width="100%"
        height={iframeHeight}
        className="block w-full border-0 bg-transparent"
        scrolling="no"
        loading="lazy"
        sandbox="allow-scripts allow-popups allow-same-origin"
        allow="camera 'none'; microphone 'none'; geolocation 'none'; payment 'none'; usb 'none'; clipboard-read 'none'; clipboard-write 'none'; fullscreen 'none'"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  )
}
